// extracted by mini-css-extract-plugin
export default {"guide-modal":"Guide_guide-modal__VZOfv","guide-header":"Guide_guide-header__9KZIz","guide-modal-content":"Guide_guide-modal-content__WZbtS"};